
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayStackedClosed as ObiTwowayStackedClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-stacked-closed.js';
 
 
 

 
 export const ObiTwowayStackedClosed = createComponent({
   react: React,
   tagName: 'obi-twoway-stacked-closed',
   elementClass: ObiTwowayStackedClosedElement,
   events: {
     
   }
  });
 
 